// extracted by mini-css-extract-plugin
export var consortium = "Partners-module--consortium--c33de";
export var main = "Partners-module--main--f5bd4";
export var sponsor = "Partners-module--sponsor--cb0c2";